import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PACKAGES, inr } from "@/data/content";

export function AdminLeaderboard() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/leaderboard").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="admin-leaderboard-page">
      <h1 className="font-display text-3xl font-bold mb-1">Leaderboard</h1>
      <p className="text-sm text-[var(--muted)] mb-6">Top partners by approved referrals and commission earned.</p>
      <div className="glass rounded-2xl p-5">
        {rows.length === 0 ? <p className="text-sm text-[var(--muted)] py-8 text-center">No partner earnings yet.</p> : rows.map((r, i) => (
          <div key={r.code} data-testid={`admin-leader-${i}`} className="flex items-center gap-4 py-3 border-b last:border-0 border-[var(--surface-border)]">
            <span className="w-8 h-8 rounded-full grid place-items-center font-bold text-sm text-[var(--on-accent)]" style={{ background: i < 3 ? "var(--btn-bg)" : "var(--bg-2)", color: i < 3 ? "var(--on-accent)" : "var(--muted)" }}>{i + 1}</span>
            <div className="flex-1"><p className="font-semibold">{r.name}</p><p className="text-xs text-[var(--muted)]">{r.code}</p></div>
            <p className="text-xs text-[var(--muted)]">{r.count} joined</p>
            <p className="font-bold text-[var(--pink)] w-24 text-right">{inr(r.amount)}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export function AdminPackages() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/packages").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="admin-packages-page">
      <h1 className="font-display text-3xl font-bold mb-1">Packages</h1>
      <p className="text-sm text-[var(--muted)] mb-6">Your four Ilmora packages, their price and how many students bought each.</p>
      <div className="grid sm:grid-cols-2 gap-5">
        {PACKAGES.map((p) => {
          const stat = rows.find((r) => r.slug === p.slug) || {};
          return (
            <div key={p.slug} data-testid={`admin-package-${p.slug}`} className="glass rounded-2xl p-6">
              <div className="flex items-start justify-between">
                <div><p className="eyebrow">{p.tag}</p><h2 className="font-display text-xl font-bold mt-2">{p.name}</h2></div>
                <div className="text-right"><p className="font-display text-2xl font-bold text-[var(--pink)]">{inr(p.price)}</p><p className="text-xs text-[var(--muted)] line-through">{inr(p.oldPrice)}</p></div>
              </div>
              <div className="flex gap-6 mt-5 text-sm">
                <div><p className="text-xs text-[var(--muted)]">Courses</p><p className="font-bold">{p.courses.length}</p></div>
                <div><p className="text-xs text-[var(--muted)]">Lessons</p><p className="font-bold">{stat.lessons_total ?? "–"}</p></div>
                <div><p className="text-xs text-[var(--muted)]">Students</p><p className="font-bold">{stat.sold ?? 0}</p></div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export function AdminEnquiries() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/enquiries").then((r) => setRows(r.data)); }, []);
  return (
    <div data-testid="admin-enquiries-page">
      <h1 className="font-display text-3xl font-bold mb-1">Leads</h1>
      <p className="text-sm text-[var(--muted)] mb-6">Enquiries from Buy Now, Contact and Help &amp; Support forms.</p>
      <div className="glass rounded-2xl p-5 overflow-x-auto">
        {rows.length === 0 ? <p className="text-sm text-[var(--muted)] py-8 text-center">No leads yet.</p> : (
          <table className="w-full text-sm min-w-[700px]">
            <thead><tr className="text-left text-xs text-[var(--muted)]"><th className="pb-3">Name</th><th>Contact</th><th>Type</th><th>Message</th><th>Date</th></tr></thead>
            <tbody>{rows.map((e) => (
              <tr key={e.id} className="border-t border-[var(--surface-border)] align-top">
                <td className="py-3 pr-4 font-semibold">{e.name}</td><td className="py-3 pr-4 text-xs">{e.phone}<br />{e.email}</td>
                <td className="py-3 pr-4 text-xs capitalize">{e.kind}{e.item ? ` · ${e.item}` : ""}</td><td className="py-3 pr-4 text-xs max-w-xs">{e.message || "—"}</td>
                <td className="py-3 text-xs">{new Date(e.created_at).toLocaleDateString("en-IN")}</td>
              </tr>))}</tbody>
          </table>
        )}
      </div>
    </div>
  );
}
